import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class GetAiAdminExecutionLogsService extends BaseService {
  constructor() {
    super(constants.GET_AI_ADMIN_EXECUTION_LOGS, constants.AI_ADMIN_EXECUTION_LOGS_STATUS);
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { requestId } = payload;
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/logs/${requestId}`, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(`/logs/${requestId}`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const store = Framework.getStoreRegistry().getStore('aiAdminExecutionLogs');

    if (data && data.success) {
      store.setResponse(data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Error fetching execution logs'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      store.setError('Logs not found');
    }
  }

  handleError(error) {
    const { response } = error;
    if (response?.status === 401) {
      utils.redirectToLogin();
    }

    Framework.getStoreRegistry().getStore('aiAdminExecutionLogs').setError('Failed to fetch execution logs');
  }
}
